<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import type { WorkRecord } from '@/types/apis/task'
import LazyMedia from '@/components/lazy-media.vue'
import { Icon } from '@iconify/vue'

interface Props {
  task: WorkRecord
}

const props = defineProps<Props>()
const { t } = useI18n()
</script>

<template>
  <div class="overflow-hidden rounded-lg bg-gray-900 active:scale-95 transition-transform">
    <div class="overflow-hidden bg-gray-800 aspect-3/4">
      <img
        v-if="task.results.videoCover"
        :src="task.results.videoCover"
        class="h-full w-full object-cover"
        alt="作品封面"
      />
      <LazyMedia
        v-else-if="task.results.videoUrl"
        :src="task.results.videoUrl"
        as="video"
        media-class="h-full w-full object-cover"
      />
      <div v-else class="flex h-full w-full items-center justify-center text-gray-600">
        <Icon icon="solar:video-library-bold-duotone" class="text-5xl" />
      </div>
    </div>
    <div class="space-y-1 p-3">
      <div class="flex items-center justify-between text-xs text-gray-500">
        <span class="px-2 py-0.5 bg-gray-800 rounded-md">{{ t('common.work') }}</span>
        <span>{{ new Date(task.CreateTime).toLocaleDateString() }}</span>
      </div>
    </div>
  </div>
</template>
